import _ from 'lodash';
import './relatedItems.scss';
import template from './relatedItems.html';

class RelatedItemsComponent{
    /*@ngInject*/
    constructor(templateData) {
        this.relatedItems = _.find(templateData.linklists, { handle: this.itemsType }).links;
        this.maxDisplayRelatedItems = 3;
    }
}

export default {
    template: template,
    bindings: {
        itemsType: '<'
    },
    controller: RelatedItemsComponent
};